import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleanalyticsComponent } from './simple-icons-googleanalytics.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleanalyticsComponent ],
    exports:      [ SimpleIconsGoogleanalyticsComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleanalyticsModule {}
